// Local translations
export const T = {
  en_GB: {
    displayMode: "Display Mode",
    assetAllocation: "Asset Allocation",
    countryExposure: "Country Exposure (Top 10)",
    regionalExposure: "Regional Exposure",
    stockSector: "Stock Sector",
    equityStyle: "Equity Style Box",
    bondSector: "Bond Sector",
    topHoldings: "Top 10 Holdings",
    xrayDataHint: "Choose which data to display from the X-Ray analysis",
    showChart: "Show Chart",
    showChartDesc: "Display the pie chart visualization",
    showTable: "Show Table",
    showTableDesc: "Display data table with color indicators",
    atLeastOneOption: "At least one display option must be selected",
  },
  nb_NO: {
    displayMode: "Visningsmodus",
    assetAllocation: "Aktivaallokering",
    countryExposure: "Landeksponering (Topp 10)",
    regionalExposure: "Regional eksponering",
    stockSector: "Aksjesektor",
    equityStyle: "Aksjestil-boks",
    bondSector: "Obligasjonssektor",
    topHoldings: "Topp 10 beholdninger",
    xrayDataHint: "Velg hvilke data som skal vises fra X-Ray-analysen",
    showChart: "Vis diagram",
    showChartDesc: "Vis kakediagramvisualisering",
    showTable: "Vis tabell",
    showTableDesc: "Vis datatabell med fargeindikatorer",
    atLeastOneOption: "Minst ett visningsalternativ må velges",
  },
} as const;
